<template>
  <div>
    <div class="iotplt-card-box">
      <search-module-goods @submit="submitSearch" />
    </div>

    <div style="padding-top: 15px">
      <a-empty v-if="!loading && producerColumns.length === 0" />

      <a-row :gutter="24" v-else>
        <a-col
          v-for="col in producerColumns"
          :key="col.id"
          :span="producerColSpan"
        >
          <producer-card
            :data="groupedData[col.id] || []"
            :producer-name="col.name"
            :loading="loading"
          />
        </a-col>
      </a-row>
    </div>
  </div>
</template>

<script>
import { findModuleGoods } from '@/api/module_goods'
import { findCommonTypeOptions } from '@/api/common_type'
import SearchModuleGoods from '@/views/agent_purchase_items/module_goods/Search'
import ProducerCard from '@/views/agent_purchase_items/module_goods/ProducerCard'

export default {
  name: 'ModuleGoodsList',
  components: {
    SearchModuleGoods,
    ProducerCard
  },
  data() {
    return {
      loading: true,
      groupedData: {},
      producerOptions: [],
      query: {}
    }
  },
  computed: {
    producerColumns() {
      return this.producerOptions.filter((opt) => (this.groupedData[opt.id] || []).length > 0)
    },
    producerColSpan() {
      const count = this.producerColumns.length
      if (count <= 0) return 24
      if (count === 1) return 8
      if (count === 2) return 8
      if (count === 3) return 8
      if (count === 4) return 6
      return 4
    }
  },
  created() {
    this.fetchProducerOptions().then(() => this.fetchData())
  },
  methods: {
    submitSearch(search) {
      this.query = Object.assign({}, this.$options.data().query, search)
      this.fetchData()
    },

    fetchProducerOptions() {
      return findCommonTypeOptions('product_module_producer').then((res) => {
        if (res.code === 0) {
          this.producerOptions = res.data || []
        }
      })
    },

    fetchData() {
      this.loading = true
      findModuleGoods(
        Object.assign({ agent_id: this.$store.getters.userAgentId }, this.query)
      ).then((res) => {
        if (res.code === 0) {
          this.groupedData = this.$lodash.groupBy(res.data || [], 'module_producer_id')
        }
        this.loading = false
      }).catch(() => {
        this.loading = false
      })
    }
  }
}
</script>
